export default function FactoringCheckIcon() {
  return (
    <svg width="104" height="94" viewBox="0 0 104 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M105 35V85C105 100 97.5 110 80 110H40C22.5 110 15 100 15 85V35C15 20 22.5 10 40 10H80C97.5 10 105 20 105 35Z"
        fill="url(#paint0_linear_469_6879)"
      />
      <path
        d="M92.5 46.25H82.5C74.9 46.25 68.75 40.1 68.75 32.5V22.5C68.75 20.45 70.45 18.75 72.5 18.75C74.55 18.75 76.25 20.45 76.25 22.5V32.5C76.25 35.95 79.05 38.75 82.5 38.75H92.5C94.55 38.75 96.25 40.45 96.25 42.5C96.25 44.55 94.55 46.25 92.5 46.25Z"
        fill="url(#paint1_linear_469_6879)"
      />
      <path
        d="M60 68.75H40C37.95 68.75 36.25 67.05 36.25 65C36.25 62.95 37.95 61.25 40 61.25H60C62.05 61.25 63.75 62.95 63.75 65C63.75 67.05 62.05 68.75 60 68.75Z"
        fill="url(#paint2_linear_469_6879)"
      />
      <path
        d="M80 88.75H40C37.95 88.75 36.25 87.05 36.25 85C36.25 82.95 37.95 81.25 40 81.25H80C82.05 81.25 83.75 82.95 83.75 85C83.75 87.05 82.05 88.75 80 88.75Z"
        fill="url(#paint3_linear_469_6879)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_469_6879"
          x1="22.9113"
          y1="60.0005"
          x2="96.7916"
          y2="60.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_469_6879"
          x1="71.1674"
          y1="32.5001"
          x2="93.7419"
          y2="32.5001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_469_6879"
          x1="38.6674"
          y1="65"
          x2="61.2419"
          y2="65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_469_6879"
          x1="40.4254"
          y1="85"
          x2="79.4178"
          y2="85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
